import React, { useCallback } from 'react';
import classNames from 'classnames';

import { useGameAudioController } from '@/shared/hooks/useGameAudioSettings';

import Button from '@/shared/components/button/Button';
import Tooltip from '@/shared/components/tooltip/Tooltip';

type AudioToggleButtonProps = {
	tooltip: string;
	className?: string;
	isOpen?: boolean;
	hiddenTooltip?: boolean;
	small?: boolean;
	onToggle?: (nextAudioOn: boolean) => void;
};

const AudioToggleButton = ({ tooltip, className, isOpen, hiddenTooltip, small, onToggle }: AudioToggleButtonProps) => {
	const { audioOn, setAudioOn } = useGameAudioController();

	const handleToggle = useCallback(() => {
		const nextAudioOn = !audioOn;
		setAudioOn(nextAudioOn);
		onToggle?.(nextAudioOn);
	}, [audioOn, onToggle, setAudioOn]);

	return (
		<Tooltip
			place="bottom"
			title={tooltip}
			className="audio-toggle-button__tooltip"
			isOpen={isOpen}
			hidden={hiddenTooltip}
		>
			<Button
				iconName={audioOn ? 'icon-music-on' : 'icon-music-off'}
				color="white"
				type="secondary"
				rounded
				small={small}
				onClick={handleToggle}
				className={classNames('audio-toggle-button', className)}
			/>
		</Tooltip>
	);
};

export default AudioToggleButton;
